import './index.css'
import StadisticTable from "../../components/StadisticTable";
import { useGetStrikersPlayer } from "./hooks/useGetStrikerPlayer";

const StrikerScreen = ()=>{
  const { selectedTournament, strikerOrder } = useGetStrikersPlayer();

    return(
      <StadisticTable 
      title={'Tabla de Goleo'}
      targetName={'Goles'}
      players={strikerOrder}
      tournament={selectedTournament}
      target={'goles'}

      />
    )
}

export default StrikerScreen